// JavaScript Document
$('#owl-demo').owlCarousel({
	loop: true,
	margin: 10,
	responsiveClass: true,
	responsive: {
		0: {
			items: 1,
			nav: true
		},
		600: {
			items: 1,
			nav: true
		},
		1000: {
			items: 1,
			nav: true,
			loop: true,
			dots: false,
			center: true
		}
	}
})

